// Import-time IIFE building one shared MeshStandardMaterial per severity (plus '-l'
// link variants). Reads localStorage.themeKey at module evaluation — keep it that way.
import { THREE } from './context.js';
import { severityTypes, colorsSeverity } from '../constants/severity.js';

export const severityColors =
  [...severityTypes, "host"]
    .map(f => {
      return {
        [f]:
          (() => {
            let baseColor;
            if (f === "host") {
              return new THREE.MeshStandardMaterial({
                //  map: texture ,
                roughness: 0.1,
                metalness: 0.5,
                side: THREE.DoubleSide,
                color: !(localStorage.getItem("themeKey") == "light") ? "#FFFFFF" : "#122221",
                emissive: !(localStorage.getItem("themeKey") == "light") ? "#FFFFFF" : "#121221",

                emissiveIntensity: 0.42,
                transparent: true,
                opacity: 1
              })

              return new THREE.MeshLambertMaterial({
                color: dark ? "#A2A3A4" : "#121221",
                emissive: dark ? "#A2A3A4" : "#121221",
                emissiveIntensity: 2,
                transparent: true,
                opacity: 1,
              });
              baseColor = "#005a01";
            } else {
              // Darken the color before using
              let orig = colorsSeverity[f] || "#EAEAEA";
              let color = new THREE.Color(orig);
              color.offsetHSL(0, 0, 0); // darken by reducing lightness
              baseColor = "#" + color.getHexString();
              // baseColor = orig;
            }
            // // Convert the base color to HSL
            // const tempColor = new THREE.Color(baseColor);
            // const hsl = {};
            // tempColor.getHSL(hsl);
            // // Create a canvas to use as a texture
            // const size = 128;
            // const canvas = document.createElement('canvas');
            // canvas.width = size;
            // canvas.height = size;
            // const ctx = canvas.getContext('2d');
            // // Create a linear gradient from darkened to lightened base color, keeping the same hue
            // // Darken for one end, lighten for the other, but keep the same hue and saturation
            // const darkL = Math.max(0, hsl.l - 0.15);
            // const lightL = Math.min(1, hsl.l + 0.15);
            // const hslStrDark = `hsl(${Math.round(hsl.h * 360)}, ${Math.round(hsl.s * 100)}%, ${Math.round(darkL * 100)}%)`;
            // const hslStrLight = `hsl(${Math.round(hsl.h * 360)}, ${Math.round(hsl.s * 100)}%, ${Math.round(lightL * 100)}%)`;
            // const gradient = ctx.createLinearGradient(0, 0, size, size);
            // gradient.addColorStop(0, hslStrDark);
            // gradient.addColorStop(1, hslStrLight);
            // ctx.fillStyle = gradient;
            // ctx.fillRect(0, 0, size, size);
            // // Create a texture from the canvas
            // const texture = new THREE.CanvasTexture(canvas);
            return new THREE.MeshStandardMaterial({
              //  map: texture ,
              roughness: 0.1,
              metalness: 0.5,
              side: THREE.DoubleSide,
              color: baseColor,
              emissive: baseColor,
              emissiveIntensity: 0.42,
              transparent: true,
              opacity: 1
            });
          })()
      }
    }).concat(
      [...severityTypes, "host"]
        .map(f => {
          return {
            [f + "-l"]:
              (() => {
                let baseColor;
                if (f === "host") {
                  return new THREE.MeshStandardMaterial({
                    color: !(localStorage.getItem("themeKey") == "light") ? "#FF0000" : "#424242",
                    emissive: !(localStorage.getItem("themeKey") == "light") ? "#FF0000" : "#424242",
                    emissiveIntensity: 0.2842,
                    roughness: 0.1,
                    metalness: 0.5,
                    transparent: true,
                    opacity: 1,
                  });
                  baseColor = "#005a01";
                } else {
                  // Darken the color before using
                  let orig = colorsSeverity[f] || "#EAEAEA";
                  let color = new THREE.Color(orig);
                  color.offsetHSL(0, 0, 0.022);
                  baseColor = "#" + color.getHexString();
                  // baseColor = orig;
                }


                return new THREE.MeshStandardMaterial({
                  color: baseColor,
                  emissive: baseColor,
                  emissiveIntensity: 0.842,
                  transparent: true,
                  roughness: 0.1,
                  metalness: 0.5,
                  opacity: 1,
                  // wireframe:true
                })

                return new THREE.LineBasicMaterial({
                  color: baseColor,
                  transparent: false,
                  opacity: 1,
                  opacityMode: "multiply"
                });

                // Convert the base color to HSL
                const tempColor = new THREE.Color(baseColor);
                const hsl = {};
                tempColor.getHSL(hsl);
                // Create a canvas to use as a texture
                const size = 128;
                const canvas = document.createElement('canvas');
                canvas.width = size;
                canvas.height = size;
                const ctx = canvas.getContext('2d');
                // Create a linear gradient from darkened to lightened base color, keeping the same hue
                // Darken for one end, lighten for the other, but keep the same hue and saturation
                const darkL = Math.max(0, hsl.l - 0.15);
                const lightL = Math.min(1, hsl.l + 0.15);
                const hslStrDark = `hsl(${Math.round(hsl.h * 360)}, ${Math.round(hsl.s * 100)}%, ${Math.round(darkL * 100)}%)`;
                const hslStrLight = `hsl(${Math.round(hsl.h * 360)}, ${Math.round(hsl.s * 100)}%, ${Math.round(lightL * 100)}%)`;
                const gradient = ctx.createLinearGradient(0, 0, size, size);
                gradient.addColorStop(0, hslStrDark);
                gradient.addColorStop(1, hslStrLight);
                ctx.fillStyle = gradient;
                ctx.fillRect(0, 0, size, size);
                // Create a texture from the canvas
                const texture = new THREE.CanvasTexture(canvas);
                return new THREE.MeshLambertMaterial({
                  map: texture,
                  transparent: true,
                  opacity: 0.02
                });
              })()
          }
        })
    )
    .reduce((acc, curr) => {
      return {
        ...acc,
        ...curr
      }
    }, {})
